<template>
  <v-sheet color="background_dark">
    <v-img
      id="pricing"
      :src="require('@/assets/pricing.png')"
      class="py-16"
      fluid
      :max-height="$vuetify.breakpoint.lg ? 800 : 'initial'"
    >
      <v-container class="align-content-center fill-height">
        <v-row class="justify-center mb-10">
          <p class="text-h4 px-4 text-center white--text font-weight-bold">
            Get up and running real fast
          </p>
        </v-row>
        <v-row class="justify-center mt-auto">
          <v-card
            class="ma-2 pa-3 d-flex flex-column"
            max-width="350px"
            min-height="500px"
          >
            <v-card-title class="justify-center font-weight-bold">
              Free Trial
            </v-card-title>

            <v-card-text
              class="text-h5 justify-center text-center black--text font-weight-bold"
            >
              <span class="text-h4 font-weight-medium">$0</span> for 30 days
            </v-card-text>

            <v-list>
            <v-list-item v-for="i in freeTier" :key="i" dense>
                <v-icon>mdi-circle-small</v-icon>
              {{ i }}
            </v-list-item>

            <v-list-item />
          </v-list>

            <!-- <v-chip label x-small>awaiting copywork</v-chip> -->

            <v-card-actions class="justify-center mt-auto">
              <v-btn
                x-large
                color="primary"
                width="100%"
                href="https://amplifylawns.com/"
              >
                Get Started
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card
            class="ma-2 pa-3 d-flex flex-column"
            max-width="350px"
            min-height="500px"
          >
            <v-card-title class="justify-center font-weight-bold d-flex">
              Basic
            </v-card-title>

            <v-card-text
              class="text-h5 justify-center text-center black--text font-weight-bold"
            >
              <span class="text-h4 font-weight-medium">$19.99</span> /month
            </v-card-text>

            <v-list>
               <v-list-item v-for="i in basicTier" :key="i" dense>
                <v-icon>mdi-circle-small</v-icon>
              {{ i }}
               </v-list-item>

            
            </v-list>

            <!-- <v-chip label x-small>awaiting copywork</v-chip> -->

            <v-card-actions class="justify-center mt-auto">
              <v-btn
                x-large
                color="primary"
                width="100%"
                href="https://amplifylawns.com/"
              >
                Get Started
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card
            class="ma-2 pa-3 d-flex flex-column"
            width="350px"
            min-height="550px"
            color="#3ad6a1"
          >
            <v-card-title class="justify-center font-weight-bold d-flex" style="color: white;">
              Pro
            </v-card-title>

            <v-card-text
              class="text-h5 justify-center text-center black--text font-weight-bold"
              style="color: white;"
              >
              <span class="text-h4 font-weight-medium" style="color: white;">$49.99 </span> <span style="color: white;"> /month </span>
            </v-card-text>
            <v-list 
            color="#3ad6a1"
            
            >

              <v-list-item
              v-for="i in proTier"
              :key="i"
              style="color: white;"
              >
                 <v-icon style="color: #FFFFFF;">mdi-circle-small</v-icon>
                  {{ i }}
              </v-list-item>
            </v-list>

            

            <v-card-actions class="justify-center mt-auto">
              <v-btn
                x-large
                color="primary"
                width="100%"
                href="https://amplifylawns.com/"
              >
                Get Started
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-row>
        <v-row class="justify-center">
          <v-sheet dark color="transparent">
            <v-card-subtitle>
              With your Amplify subscription you get a Stripe Connect Express account.  Amplify pays the $2/month charge, and the Stripe processing fees are deducted from your payments.  More details <a href="https://stripe.com/connect" target="_blank">here</a>.
            </v-card-subtitle>
          </v-sheet>
        </v-row>
      </v-container>
    </v-img>
  </v-sheet>
</template>

<script>
export default {
  name: "pricingPage",
  data: () => ({
    freeTier: [
      "Get all the features free for 30 days",
      "Organize your lawn business",
      "Collect your $$ faster",
      "Communicate with Customers",
      "Access to in-app Support Chat",
    ],
    basicTier: [
      "Organize your lawn business",
      "Collect your $$ faster",
      "Communicate with Customers",
      "In-app Support Chat",
      "Increase Customer satisfaction with status messaging and easy payment options",

    ],
    proTier: [
      "Includes all Basic features",
      "Send quotes",
      "Unlimited team member logins",
      "API intergration",
    ],
  }),
};
</script>
